import * as angular from "angular";
import { CampaignDataProvider } from "../../../data-provider/campaign.dp";
import { FilterDataProvider } from "../../../data-provider/filter.dp";
import { Campaign } from "../../../models/campaign.model";
import { User } from "../../../models/user.model";
import { NavigationBarHelperService } from "../../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../../shared/permission";
import { UserDataProvider } from "../../../data-provider/user.dp";
import { InviteDataProvider } from "../../../data-provider/invite.dp";
import { DialogUtils } from "../../../helper/dialog.helper";

let TeamTabsComponent = {
    selector: "vcTeamTabs",
    templateUrl: "/angular/components/team/tabs/team-tabs.component.html",
    bindings: {
        activeTab: "=?",
        create: "=?",
        showing: "=?",
        provider: "=?",
        itemType: "=?",
        items: "=?",
        function: "&?",
    },
    controller: class TeamTabsController {
        // * bindings for typescript compiler *
        public activeTab?: any;
        public create?: any;
        public showing?: any;
        public provider?: any;
        public itemType?: any;
        public items?: any;
        public function?: any;
        // ************************************

        public isLeaderView: boolean;
        public isOrgCampaign: boolean;
        public activeCampaign: Campaign;
        public signedInUser: User;

        private readonly $scope: any;
        private $window: any;
        private readonly dialog: DialogUtils;

        private userDataProvider: UserDataProvider;
        public inviteDataProvider: InviteDataProvider;
        public navigationBarService: NavigationBarHelperService;
        public filterDataProvider: FilterDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $window: any,
            DialogUtils: DialogUtils,
            __app_type: string,
            NavigationBarHelperService: NavigationBarHelperService,
            UserDataProvider: UserDataProvider,
            InviteDataProvider: InviteDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            FilterDataProvider: FilterDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.dialog = DialogUtils;

            this.navigationBarService = NavigationBarHelperService;
            this.userDataProvider = UserDataProvider;
            this.inviteDataProvider = InviteDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.filterDataProvider.setPage("users");
            this.permissionProvider = PermissionCheck;

            this.isLeaderView = __app_type == "LEADER";
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.signedInUser = UserDataProvider.getActiveUser();
            this.isOrgCampaign =
                __app_type == "USER" &&
                this.activeCampaign.isOrganisationCampaign();
        }

        $onInit(): void {
            this.permissionProvider.getFeaturePermissions().then(() => {
                // The invites page loads (and filters) the invite list itself;
                // on the other tabs load it here so the pending-approval badge
                // can show without visiting the invites tab first.
                if (
                    this.activeTab != "invites" &&
                    this.permissionProvider.hasPermission("CREATE_TEAM")
                ) {
                    this.inviteDataProvider.all();
                }
            });
        }

        navigateTo(location: string): void {
            if (location == "map" || location == "teams") {
                this.navigationBarService.setFilterBarOpen(false);
            }
            this.$window.location =
                "/#/" +
                location +
                "?filter=" +
                JSON.stringify(
                    this.filterDataProvider.appliedFilter.nonEmptyValues()
                );
        }

        openManageLicensesDialog(event: any): void {
            this.dialog
                .show({
                    component: "license-info-dialog",
                    targetEvent: event,
                    size: "large",
                    scope: this.$scope,
                    locals: {},
                })
                .then(() => {
                    if (
                        this.permissionProvider.hasStripeSubscription &&
                        !this.permissionProvider.isYearlySubscrition &&
                        this.permissionProvider.hasBillingRight()
                    ) {
                        this.openChooseQuantityDialog();
                    } else {
                        let message: string;
                        if (
                            !this.permissionProvider.hasStripeSubscription ||
                            this.permissionProvider.isYearlySubscrition
                        )
                            message =
                                "Please contact support@ecanvasser.com or sales@ecanvasser.com to request more user licenses";
                        else if (!this.signedInUser.billing)
                            message =
                                "You need to have billing permission to make this change";

                        this.dialog.showPreConfiguredDialog(
                            this.dialog
                                .confirm()
                                .textContent(message)
                                .targetEvent(event)
                                .ok("OK")
                        );
                    }
                });
        }

        openChooseQuantityDialog(): void {
            this.dialog
                .show({
                    component: "vc-seats-settings-dialog",
                    size: "large",
                    scope: this.$scope,
                    locals: {},
                })
                .then((numSeats: any) => {
                    this.dialog.hide();
                    this.openPurchaseSeatsDialog(numSeats);
                });
        }

        openPurchaseSeatsDialog(numSeats: any): void {
            this.dialog
                .show({
                    component: "purchase-seats-dialog",
                    size: "large",
                    scope: this.$scope,
                    multiple: false,
                    locals: {
                        numSeats: numSeats,
                    },
                })
                .then(() => this.userDataProvider.resetUsersCount());
        }
    },
};

angular.module("team").component(TeamTabsComponent.selector, TeamTabsComponent);
